export const Category = {
  FACULTAD: '8D4AC262-FC39-48B6-80C1-9C9CB23E9333',
  CARRERA: '2FE05DD7-E8C6-4B95-BC2A-42A25644EF4B',
  SEDE: 'D66E1E89-E822-4920-BF10-26E0C8EC85BE',
  UNIDAD_GESTION: '6459B401-7B05-4664-AE3B-579FC8024E32',
  ADMINISTRATIVO: 'DF28081E-9A39-4E2C-9271-32737B162EEA'
};

export const Position = {
  COORDINADOR: '2CEC1C0F-3C9E-4343-8471-1BCA5258295E',
  DECANO: '92EECD8E-5633-4FAF-B521-45D53A7E4BF8',
  DIRECTOR: 'D9B785F9-BD53-4E90-AEAF-719B1D7F6C38',
  RECTOR: 'CFCA7981-7623-4FEA-9D72-7C53CE243754',
  SECRETARIO_ACADEMICO: 'D4BD90F1-561A-4580-A855-F187C235AF8E',
  SECRETARIO_ADMINISTRATIVO: '2D69B426-C716-4124-AFD8-8DD0137615BF',
  SECRETARIO_TECNICO: 'BB52049D-DC3A-41C1-84C9-D01F34A65282',
  VICEDECANO: '2EAB1050-3618-488E-9942-FEE814D2B8DD',
  VICERRECTOR: '4198820B-A6D3-485E-88E0-9BA96763CD12',
  DELEGADO_SUPERIOR: '3F613114-827C-4041-8421-D13943B25ED9',
  TUTOR_INICIACION: '2CAAA713-8DC9-4300-BE7C-7C1D890E481F',
  DISENADOR_GRAFICO: '8A010302-B5D8-4B2B-9936-211E848796C3',
  ASESOR_PEDAGOGICO: '87667FD0-2252-4EAE-BC6A-C71CD0575CF3',
  MENTOR_ONLINE: '12549552-C3F3-4806-8E21-2BC2337FAF65',
  ASESOR_PEDAGOGICO_INDUCCION: '3BAFF8FD-E588-4BA3-81AB-EBD176F654F5',
  DIRECTOR_OPERATIVO: 'F94A2968-4CE3-4127-AD61-6B830DF7F67C',
  COORDINADOR_TIC: 'B35C1872-346D-48CB-958F-B90091624B9E',
  COORDINADOR_OPERATIVO_HOSPITAL: '820E4374-9F8F-4BCD-8FC8-2101795E0FB0',
  COORDINADORA_MENTORIA: 'E7C77E38-3BBB-476B-BDF3-9415C53ABBB7',
  ASESOR: '52806090-F661-4DC4-A898-47B33D632695',
};
/*
  Rector,
  viceRector,
  Decano,
  Vicedecano,
  secretario academico/tecnico/administrativo,
  delegado superior,
  otros
*/